import { AnimatePresence, motion } from 'motion/react';
import { Loader, useBodyScrollLock } from '../../modules/design-system';
import { useBackBlocker } from '../../modules/backStack';

export interface SellingOverlayProps {
  visible: boolean;
}

/**
 * Full-page block during a bulk inventory sell. Mirrors the purchase
 * `PurchaseOverlay` look (dim+blur backdrop, white brand loader, motion
 * fade) so the busy state is consistent across the buy and sell flows.
 */
export function SellingOverlay({ visible }: SellingOverlayProps) {
  // This overlay stays mounted while hidden, so the lock follows `visible`.
  useBodyScrollLock(visible);
  // Host back button (modules/backStack) is swallowed while the sell runs.
  useBackBlocker(visible);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="selling-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="
            safe-area-pad fixed inset-0 z-50 flex items-center justify-center
            bg-black/70 backdrop-blur-md
            px-4
          "
          role="dialog"
          aria-modal="true"
          aria-label="Selling cards"
        >
          <div className="flex flex-col items-center gap-4 text-white">
            <Loader />
            <p className="type-headline font-semibold">Processing buyback...</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
